/**
 *  oss api
 *  @author cpc
 */
import * as API from '..'
import $const from '../../common/constant'

export default {
  /**
   * get upload token
   * @param params
   * @returns  result upload token
   */
  token: params => {
    return API.GET($const.apiServer.Base + '/oss/qi_niu/token', params);
  },
  /**
   * get download url
   * @param params
   * @returns {Promise<*>}
   */
  privateDownloadUrl: params => {
    return API.GET($const.apiServer.Base + '/oss/qi_niu/privateDownloadUrl', params);
  },
}




// WEBPACK FOOTER //
// ./src/api/oss/api_oss.js